import ThreeDSlider from "@/themes/kulturklub/ThreeDSlider";
import HomeInfoSection from "@/themes/kulturklub/HomeInfoSection";
import PastEventsSlider from "@/themes/kulturklub/PastEventsSlider";
import FeaturedEvent from "@/themes/kulturklub/FeaturedEvent";
import EventsBlock from "@/themes/kulturklub/EventsBlock";
//import GoogleReviewsWidget from "./GoogleReviewsWidget";
import { Dancing_Script } from "next/font/google";
import Head from "next/head";

const ds = Dancing_Script({
    weight: ["400", "500", "600", "700"], // amire szükség van
    subsets: ["latin"],
});

// <GoogleReviewsWidget vendorId={1} />

export default function ThemedIndex({ products }) {

    return (
        <>
            <Head>
                <title>KulturKlub.Eu..élményből sosem elég!</title>
                {/* opcionális SEO */}
                <meta name="description" content="Felejthetetlen élményeket keresel? A KultúrKlub programjait mi álmodjuk meg és valósítjuk meg, mindig egy csipetnyi különlegességgel." />
            </Head>

            <ThreeDSlider />
            <HomeInfoSection />
            <EventsBlock products={products} />
            <PastEventsSlider products={products} />
            <FeaturedEvent />

        </>
    );
}

